import axios from "axios";
import { ENV, validateErrorResponse } from "../config/ENV";
import firebase from "firebase/compat/app";
import axiosInterceptors from "./axiosInterceptors";

export default function candidateLogin() {
  return axios({
    method: "post",
    url: ENV.login_url,
    headers: {
      Authorization: "Bearer " + window.localStorage.authToken,
    },
  })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

// export default function candidateLogin() {
//   return axiosInterceptors
//     .post(ENV.login_url)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       return error;
//     });
// }

export function saveUserDetails(signUpReqest) {
  return axiosInterceptors
    .post(ENV.signup_url, signUpReqest)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
}

export function candidateLogout() {
  return axiosInterceptors
    .post(ENV.login_url)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      firebase
        .auth()
        .signOut()
        .then(function () {
          window.localStorage.removeItem("user");
          window.localStorage.removeItem("account");
          window.localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/";
        })
        .catch(function () {
          window.localStorage.removeItem("user");
          window.localStorage.removeItem("account");
          window.localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/";
        });
      return error;
    });
}
